import { Link } from 'react-router-dom';
import { IAssignmentNextLesson } from '@/entities/Assignment';
import FilesIcon from '@/shared/assets/icons/files.svg';
import { Svg } from '@/shared/ui/Svg';

interface AssignmentNextLessonProps {
  nextLesson: IAssignmentNextLesson;
  href: string;
}
export const AssignmentNextLesson = ({ nextLesson, href }: AssignmentNextLessonProps) => (
  <Link to={href} className="flex p-4 items-center gap-4 cursor-pointer bg-white rounded-2xl">
    <Svg Icon={FilesIcon} />
    <div className="flex flex-col gap-2">
      <p className="leading-[1.4] tracking-normal">Go to the session</p>
      <p className="text-[18px] tracking-normal leading-[1.2] font-medium ">
        {nextLesson.order}. {nextLesson.title}
      </p>
    </div>
  </Link>
);
